// @flow

/**
 * DO NOT EDIT THIS FILE MANUALLY
 * Generated by `Opus::GeneratedFileVerifier::Generators::DocsApiClientGenerator`
 * If this file is out-of-sync or causing builds to fail, try running `scripts/bin/sync-generated`
 */
import type {ApiRequestExecutor} from '../ApiRequestExecutor';

import type {
  GenerateExampleSnippetRequestModel,
  GenerateExampleSnippetResponseModel,
  VideosManifestModel,
  ModelsPayoutsAlternativeCurrencySettlementFees,
  GetConnectPayoutCurrenciesEndpointResponseModel,
  ModelsPayoutsNonLocalSettlementCurrencies,
  SaveAccountSettingsEndpointRequestModel,
  SaveAccountSettingsEndpointResponseModel,
} from '../../../../../types';

export class ApiClient {
  _executor: ApiRequestExecutor;

  constructor(executor: ApiRequestExecutor) {
    this._executor = executor;
  }

  async acceptAchTos(): Promise<void> {
    return this._executor.execute({
      endpointId: 'accept_ach_tos',
      method: 'post',
      payload: null,
    });
  }

  async createCheckoutSession(payload: {[string]: any}): Promise<{[string]: any}> {
    return this._executor.execute({
      endpointId: 'create_checkout_session',
      method: 'post',
      payload,
    });
  }

  async createPaymentIntent(payload: {[string]: any}): Promise<{[string]: any}> {
    return this._executor.execute({
      endpointId: 'create_payment_intent',
      method: 'post',
      payload,
    });
  }

  async createProductAndPrice(payload: {[string]: any}): Promise<{[string]: any}> {
    return this._executor.execute({
      endpointId: 'create_product_and_price',
      method: 'post',
      payload,
    });
  }

  async createSetupIntent(payload: {[string]: any}): Promise<{[string]: any}> {
    return this._executor.execute({
      endpointId: 'create_setup_intent',
      method: 'post',
      payload,
    });
  }

  async emailSignup(payload: {[string]: any}): Promise<{[string]: any}> {
    return this._executor.execute({
      endpointId: 'email_signup',
      method: 'post',
      payload,
    });
  }

  async generateExampleSnippet(payload: GenerateExampleSnippetRequestModel): Promise<GenerateExampleSnippetResponseModel> {
    return this._executor.execute({
      endpointId: 'generate_example_snippet',
      method: 'get',
      payload,
    });
  }

  async getAllVideos(): Promise<VideosManifestModel> {
    return this._executor.execute({
      endpointId: 'get_all_videos',
      method: 'get',
      payload: null,
    });
  }

  async getAlternativeCurrencySettlementFees(): Promise<ModelsPayoutsAlternativeCurrencySettlementFees> {
    return this._executor.execute({
      endpointId: 'get_alternative_currency_settlement_fees',
      method: 'get',
      payload: null,
    });
  }

  async getConnectPayoutCurrencies(): Promise<GetConnectPayoutCurrenciesEndpointResponseModel> {
    return this._executor.execute({
      endpointId: 'get_connect_payout_currencies',
      method: 'get',
      payload: null,
    });
  }

  async getNonLocalPayouts(payload: {[string]: any}): Promise<ModelsPayoutsNonLocalSettlementCurrencies> {
    return this._executor.execute({
      endpointId: 'get_non_local_payouts',
      method: 'get',
      payload,
    });
  }

  async getPrices(): Promise<{[string]: any}> {
    return this._executor.execute({
      endpointId: 'get_prices',
      method: 'get',
      payload: null,
    });
  }

  async getRequiredVerificationInformationSummary(payload: {[string]: any}): Promise<{[string]: any}> {
    return this._executor.execute({
      endpointId: 'get_required_verification_information_summary',
      method: 'get',
      payload,
    });
  }

  async getTaxData(): Promise<{[string]: any}> {
    return this._executor.execute({
      endpointId: 'get_tax_data',
      method: 'get',
      payload: null,
    });
  }

  async renderSavedDraft(): Promise<void> {
    return this._executor.execute({
      endpointId: 'render_saved_draft',
      method: 'get',
      payload: null,
    });
  }

  async saveAccountSettings(payload: SaveAccountSettingsEndpointRequestModel): Promise<SaveAccountSettingsEndpointResponseModel> {
    return this._executor.execute({
      endpointId: 'save_account_settings',
      method: 'post',
      payload,
    });
  }

  async savePrefs(payload: {[string]: any}): Promise<{[string]: any}> {
    return this._executor.execute({
      endpointId: 'save_prefs',
      method: 'post',
      payload,
    });
  }

  async sendCsatFeedback(payload: {[string]: any}): Promise<void> {
    return this._executor.execute({
      endpointId: 'send_csat_feedback',
      method: 'post',
      payload,
    });
  }

}
